module.exports = __webpack_public_path__ + "prod/1.42.2/img/customer-30.08ae72c5.jpg";